import moment from "moment";
import React, { createRef, useState } from "react";
import { withRouter } from "react-router-dom";
import ReactTooltip from "react-tooltip";

import { Store__System } from "@talentbait/shared-components";

import logger from "../../../utils/LoggerFrontend";
import { withRefluxStore, StatusStore } from "../../../Stores";
import * as Styled from "./CreativesPerformanceTable.styled";
import {
  createDownloadScreenshot,
  createComponentData
} from "./services/creativesPerformanceTable";
import {
  isMetricPerformanceGood,
  isMetricPerformanceBad,
  isMetricPerformanceAverage
} from "./services/metricsAnalysis";
import { useTranslation } from "react-i18next";
import { formatIntlNumber } from "../../../utils/Helpers";
import { getCTRBarWidth } from "../CreativesPerformanceTableReport/CreativesPerformanceTableReport.utils";
import { IconCheck } from "../../../Components/Icons/Check";

const TabCreativesPerformance = ({
  campaignData,
  userProfile,
  channelCampaigns = [],
  children = []
}) => {
  const { t } = useTranslation();
  const [showAdminData, setShowAdminData] = useState(true);
  const [defaultSortOrder, setDefaultSortOrder] = useState(-1);
  const [defaultSortingField, setDefaultSortingField] = useState("ctr");

  // Usefull fields
  const { campaignName, companyName } = campaignData;
  const refForScreenShot = createRef(null);

  const downloadScreenshot = createDownloadScreenshot(
    setShowAdminData,
    userProfile,
    refForScreenShot
  );
  const {
    startDate,
    endDate,
    activeDays,
    scale,
    highestImpressionValue,
    creativesMetricsSorted,
    metricsLastFetchDay
  } = createComponentData(channelCampaigns, defaultSortingField, defaultSortOrder);

  logger.log("channelCampaigns:creatives_Performance", "called", {
    channelCampaigns,
    startDate,
    endDate,
    activeDays,
    highestImpressionValue,
    creativesMetricsSorted,
    scale
  });

  return (
    <Styled.MainWrapper className="creative-metrics">
      <div style={{ padding: "0px 20px" }}>
        {activeDays < 7 && (
          <Styled.ActiveDays>
            ⚠️ We gathered insufficient data for these creatives, wait until the learning phase is
            over
          </Styled.ActiveDays>
        )}

        <div style={{ float: "right" }}>
          <Styled.ButtonDownload onClick={downloadScreenshot}>
            {children}Download Image
          </Styled.ButtonDownload>
        </div>
      </div>
      <div>Metrics last fetch: {metricsLastFetchDay} </div>
      <div style={{ padding: "20px" }} ref={refForScreenShot}>
        <Styled.Headline>Creative Performance Report</Styled.Headline>
        <h3>Company: {companyName}</h3>
        <h3>Campaign: {campaignName}</h3>
        {startDate && endDate && (
          <Styled.CampaignDuration>
            <h3>
              Laufzeit: {moment(startDate).format("DD.MM")} - {moment(endDate).format("DD.MM.YYYY")}
            </h3>
            <h3>Läuft seit {activeDays} Tagen</h3>
          </Styled.CampaignDuration>
        )}
        <br />
        <Styled.Table>
          <Styled.Thead>
            <tr>
              <Styled.HeadTd>#</Styled.HeadTd>
              <Styled.HeadTd style={{ width: 200 }}>{t("Creative")}</Styled.HeadTd>
              {/* <Styled.HeadTd>Channel</Styled.HeadTd> */}
              <Styled.HeadTd style={{ width: 100 }}>{t("Status")}</Styled.HeadTd>
              <Styled.HeadTd>Recommendation</Styled.HeadTd>

              <Styled.HeadTd
                isActive={defaultSortingField == "impressions"}
                onClick={() => {
                  if (defaultSortingField == "impressions") {
                    setDefaultSortOrder(defaultSortOrder * -1);
                  }

                  setDefaultSortingField("impressions");
                }}
              >
                Impressions
              </Styled.HeadTd>
              <Styled.HeadTd
                isActive={defaultSortingField == "clicks"}
                onClick={() => {
                  if (defaultSortingField == "clicks") {
                    setDefaultSortOrder(defaultSortOrder * -1);
                  }
                  setDefaultSortingField("clicks");
                }}
              >
                Clicks
              </Styled.HeadTd>
              <Styled.HeadTd
                isActive={defaultSortingField == "results.value"}
                onClick={() => {
                  if (defaultSortingField == "results.value") {
                    setDefaultSortOrder(defaultSortOrder * -1);
                  }
                  setDefaultSortingField("results.value");
                }}
              >
                Results
              </Styled.HeadTd>
              <Styled.HeadTd
                isActive={defaultSortingField == "ctr"}
                onClick={() => {
                  if (defaultSortingField == "ctr") {
                    setDefaultSortOrder(defaultSortOrder * -1);
                  }
                  setDefaultSortingField("ctr");
                }}
              >
                CTR
              </Styled.HeadTd>
            </tr>
          </Styled.Thead>

          {creativesMetricsSorted.map((metrics, index) => {
            // Useful constants for rendering
            const { impressions, inlineClicks, date_start, status, asset } = metrics;
            const insufficientImpressions = parseInt(impressions || 0) < 1000;
            const creativeActiveDays = Math.abs(moment(date_start).diff(new Date(), "days"));

            return (
              <Styled.TableRow
                key={metrics?.adId || asset?.hash}
                deactivated={insufficientImpressions}
              >
                <Styled.CreativeIndex style={{ padding: 10, textAlign: "center" }}>
                  <div>{index + 1}</div>
                  <Styled.StatusIndicator status={status}></Styled.StatusIndicator>
                  {metrics.asset.type == "image" ? (
                    <Styled.CreativeType> 🏞 </Styled.CreativeType>
                  ) : (
                    <Styled.CreativeType> 🎥 </Styled.CreativeType>
                  )}
                </Styled.CreativeIndex>
                <Styled.Td key={metrics?.asset?.id} style={{ padding: 10, textAlign: "right" }}>
                  <Styled.NoticeWrap>
                    <Styled.PerformanceImg src={metrics && metrics.asset.url} />
                    <Styled.ActiveDays>{creativeActiveDays} Active Days</Styled.ActiveDays>
                  </Styled.NoticeWrap>
                </Styled.Td>

                <Styled.Td style={{ padding: 10, minWidth: "40", textAlign: "center" }}>
                  {insufficientImpressions ? (
                    <Styled.BadgeWrapper
                      bg="#ffd36f"
                      data-tip="This ad creative is still gathering data"
                    >
                      ⏳
                    </Styled.BadgeWrapper>
                  ) : (
                    <Styled.BadgeWrapper bg="#3b7eeb">
                      <IconCheck
                        color="transparent"
                        dataTip="This ad creative has been analyzed"
                        size={24}
                      />
                    </Styled.BadgeWrapper>
                  )}
                </Styled.Td>

                <Styled.Td style={{ textAlign: "center" }}>
                  {isMetricPerformanceGood({ inlineClicks, impressions }) &&
                    !insufficientImpressions && (
                      <Styled.GoodPerformance>
                        👍🏻 Great! This image is performing well with your candidates
                      </Styled.GoodPerformance>
                    )}
                  {isMetricPerformanceBad({ inlineClicks, impressions }) &&
                    !insufficientImpressions && (
                      <Styled.BadPerformance>
                        👎🏻 This image is not attracting your candidates
                      </Styled.BadPerformance>
                    )}
                  {isMetricPerformanceAverage({ inlineClicks, impressions }) &&
                    !insufficientImpressions && (
                      <Styled.AveragePerformance>
                        ⚖️ This image has an average performance
                      </Styled.AveragePerformance>
                    )}
                  {insufficientImpressions && (
                    <Styled.GatheringData>
                      🔎 This image is still gathering data
                    </Styled.GatheringData>
                  )}
                </Styled.Td>

                {parseInt(impressions) == highestImpressionValue ? (
                  <Styled.StrongTd style={{ padding: 10, textAlign: "center" }}>
                    {formatIntlNumber(impressions, { language: userProfile?.language })}
                  </Styled.StrongTd>
                ) : (
                  <Styled.Td style={{ padding: 10, textAlign: "center" }}>
                    {formatIntlNumber(impressions, { language: userProfile?.language })}
                  </Styled.Td>
                )}

                <Styled.Td style={{ padding: 10, textAlign: "center" }}>
                  {parseFloat(metrics.inlineClicks || 0)}
                </Styled.Td>
                <Styled.Td style={{ padding: 10, textAlign: "center" }}>
                  <div>
                    <div>{metrics.results.value}</div>
                    <div style={{ color: "lightgray" }}>{metrics.results.fieldText}</div>
                  </div>
                </Styled.Td>
                <Styled.Td style={{ padding: 10 }}>
                  <Styled.Bar
                    width={getCTRBarWidth(scale, metrics.inline_link_click_ctr)}
                    learningPhase={insufficientImpressions}
                  />
                  <Styled.BarLabel title={`${metrics.inline_link_click_ctr}%`}>
                    {(parseFloat(metrics.inline_link_click_ctr) || 0).toFixed(2)}%
                  </Styled.BarLabel>
                </Styled.Td>
              </Styled.TableRow>
            );
          })}
        </Styled.Table>
      </div>
      <ReactTooltip effect="solid" />
    </Styled.MainWrapper>
  );
};

export default withRefluxStore(
  withRouter(TabCreativesPerformance),
  [StatusStore, Store__System],
  ["campaignData", "adsets", "channelCampaigns", "userProfile"]
);
